import {
	GET_ACTIVITIES,
	GET_ELEMENT_TASK_COMPLETION,
} from '../actions/ElementViewActions.js';

const initialState = {
	formState: {
		isValid: false,
		values: {},
		touched: {},
		errors: {},
	},
	activities: [],
};

const activityViewReducer = (state = initialState, action) => {
	switch (action.type) {
					case GET_ACTIVITIES: {
						return {
							...state,
							activities: action.activities
						};
					}
					case GET_ELEMENT_TASK_COMPLETION: {
						return {
							...state,
							elementTaskCompletion: action.elementTaskCompletion
						};
					}
					default: {
						return state;
					}
	}
};

export default activityViewReducer;
